import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const VendorInvoiceContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",

  "& > .MuiGrid-root, & > .MuiFormControl-root": {
    margin: "0 0 10px 0",
  },
});

export const VatContainer = styled(Grid)({
  "& > .MuiAutocomplete-root": {
    width: "800px",
  },
});
